import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reportv2Tab, Reportv2TabList } from '../reportv2.const';
import { ReportService } from '../../../../../common/services/Report.service';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import ExportDataModule from 'highcharts/modules/export-data';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';
declare var require: any;
const moment = require('moment');

@Component({
  selector: 'report-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css'],
  providers: [ReportService, ExportCustomService],
})
export class CustomerComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();

  public dataCustomerByChannelKeyLists: any = [];

  public TicketTrendCategories: any = [];
  public dataCustomerByChannel: any = [];
  public dataSummaryWorkingTime: any = [];
  public isLoading: boolean = true;

  public modelFilter: any = {
    from_date: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
    to_date: new Date(),
  };

  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;
  public exportType = {
    CustomerByChannel: 'CustomerByChannel',
  };
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private exportCustomService: ExportCustomService
  ) {
    super(changeDetector, toastr, modalService);
  }
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;

  async ngOnInit() {
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    let payload = {
      from_date: moment(this.modelFilter.from_date).format('YYYY-MM-DD'),
      to_date: moment(this.modelFilter.to_date).subtract(1, 'days').format('YYYY-MM-DD'),
    };

    this.reportService.customerv2(payload).subscribe(res => {
      this.generateDataCustomerByChannel(res.data);
      this.isLoading = false;
    });
  }

  generateDataCustomerByChannel(data) {
    this.TicketTrendCategories = data.map(value => value.time);

    this.dataCustomerByChannelKeyLists = [];
    data.map((value, index) => {
      value.contacts.map(e => {
        if (!this.dataCustomerByChannelKeyLists.find(item => item.name == e.title)) {
          this.dataCustomerByChannelKeyLists.push({
            name: e.title,
          });
        }
      });
    });

    const dataSeries = this.dataCustomerByChannelKeyLists.map(value => {
      let datas = [];
      data.map(item => {
        let val = item.contacts.find(e => e.title == value.name);
        datas.push(val ? val.count : 0);
      });
      return {
        name: value.name,
        data: datas,
      };
    });

    const CustomerByChannelElement = document.getElementById('CustomerByChannel');
    const widthCustomerByChannel = CustomerByChannelElement.offsetWidth;

    this.dataCustomerByChannel = {
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              {
                text: 'Download PNG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/png',
                    filename: `Thống kê kênh tương tác ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download JPEG image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/jpeg',
                    filename: `Thống kê kênh tương tác ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download PDF document',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'application/pdf',
                    filename: `Thống kê kênh tương tác ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download SVG vector image',
                onclick: function () {
                  const currentDate = moment();
                  const formattedDate = currentDate.format('YYYY-MM-DD  HH-mm-ss');
                  this.exportChart({
                    type: 'image/svg+xml',
                    filename: `Thống kê kênh tương tác ${formattedDate}`,
                  });
                },
              },
              {
                text: 'Download Excel',
                onclick: () => {
                  this.export(this.exportType.CustomerByChannel);
                },
              },
            ],
            symbol: 'menu',
            symbolStroke: '#666666',
            symbolStrokeWidth: 3,
            symbolSize: 12,
            symbolX: 12.5,
            symbolY: 10.5,
            verticalAlign: 'top',
            y: -16, // Di chuyển nút lên trên 40px
          },
        },
      },
      chart: {
        type: 'column',
        height: window.innerHeight - 200,
        width: widthCustomerByChannel - 50,
      },
      title: {
        text: '  ',
      },
      xAxis: {
        categories: this.TicketTrendCategories,
        title: {
          text: '  ',
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Số lượng khách hàng',
        },
      },
      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        backgroundColor: 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false,
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
      },
      plotOptions: {
        column: {
          grouping: true,
          stacking: null,
          dataLabels: {
            enabled: false, // Ẩn chỉ số ở các cột
          },
        },
      },
      series: dataSeries,
    };
  }

  export(type): void {
    console.log(type, 'item');
    let exportDatas: any = {
      data: [],
    };
    let data: any = {};
    let title = '';
    switch (type) {
      case this.exportType.CustomerByChannel:
        this.TicketTrendCategories.map((value, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Thời gian'] = value;
          this.dataCustomerByChannel.series.map((val: any) => {
            data_json[val.name] = val.data[index];
          });
          exportDatas.data.push(data_json);
        });
        data['title'] = 'Báo cáo khách hàng';
        data['column'] = ['STT', 'Thời gian', ...this.dataCustomerByChannelKeyLists.map((val: any) => val.name)];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment(this.modelFilter.from_date).format('YYYY-MM-DD')} - Đến ngày: ${moment(this.modelFilter.to_date).format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 24, ...this.dataCustomerByChannelKeyLists.map((val: any) => 24)];
        title = 'Báo cáo khách hàng';
        break;
      default:
        break;
    }

    this.exportCustomService.exportExcelCustom(
      exportDatas.data,
      title + ' ' + moment(new Date()).format('YYYY-MM-DD HH-mm'),
      data // Adding a default sheet name as the third argument
    );
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngAfterViewInit(): void {}

  onDateChange(key, value): void {
    this.loadData();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/customer/customer.component.ts